import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Typography,
} from "@material-ui/core";

import { ValidatorForm } from "react-material-ui-form-validator";

import ChevronDown from "../../UI/ChevronDown";
import AlertCircle from "../../UI/AlertCircle";
import CheckCircle from "../../UI/CheckCircle";
import BuscadorMateriales from "../../UI/BuscadorMateriales";
import { AutorizacionesMaterial } from "../AutorizacionesMaterial";

import { startAlerta } from "../../../../actions/ui/alertas";
import { setearValorEnPractica } from "../../../../actions/autorizaciones/Autorizaciones";
import {
  AUTORIZACIONES_BANDEJAS,
  AUTORIZACIONES_MATERIALES_ESTADOS,
  AUTORIZACIONES_PRESUPUESTOS_ESTADOS,
  AUTORIZACIONES_SOLICITUDES_ESTADOS,
  TIPOS_AUTORIZACIONES,
} from "../../../../utils/constants";

export const AutorizacionesAccordionMateriales = (props) => {
  const dispatch = useDispatch();

  const { estadoSolicitudes, presupuestoSeleccionado, solicitudSeleccionada } = useSelector((state) => state.autorizaciones);

  const codigoMaterialRef = useRef(null);

  const [codigoMaterial, setCodigoMaterial] = useState(null);

  const onSubmitHandler = (e) => {
    if (codigoMaterial) {
      
      const material = { ...codigoMaterial, cantidad: 1 };
      const materialesAux = props.practica?.materiales ? [...props.practica?.materiales, material] : [material];

      const materialesFormateados = materialesAux.map((material) => {
        return {
          material: material.material ? material.material : material,
          cantidad: material?.cantidad,
          valorUnitario: material?.valorUnitario,
          idMaterial: material?.codigoNum || material.idMaterial,
          recuperoSur: material?.sur,
          idEstadoMaterial: (props.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
            props.permisoIngresoInterDom && material.estadoMaterial)
            ? material.estadoMaterial.idEstado
            : AUTORIZACIONES_MATERIALES_ESTADOS.PENDIENTE,
          disponible: false,
        };
      });
      dispatch(
        setearValorEnPractica(
          props.practica?.idCodNom,
          "materiales",
          materialesFormateados
        )
      );
      codigoMaterialRef.current.resetValues();
      setCodigoMaterial(null);
    } else {
      dispatch(startAlerta("Ingrese un material", "warning", "Atencion"));
    }
  };

  const enabledRecupSur = props.idTipoSolicitud !== TIPOS_AUTORIZACIONES.PRESUPUESTOS
    ? (parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE ||
      parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS ||
      parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO ||
      parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES ||
      parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA) ||
    (!props.permiteAgregarPracticaPeriodo && parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA &&
      props.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA)
    : presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE;


  const enabledMaterialActions = (props.idTipoSolicitud !== TIPOS_AUTORIZACIONES.PRESUPUESTOS
    ? ((parseInt(estadoSolicitudes) ===
      AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE ||
      parseInt(estadoSolicitudes) ===
      AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA ||
      parseInt(estadoSolicitudes) ===
      AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION ||
      parseInt(estadoSolicitudes) ===
      AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS ||
      parseInt(estadoSolicitudes) ===
      AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO ||
      parseInt(estadoSolicitudes) ===
      AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA || (props.permiteAgregarPracticaPeriodo &&
        parseInt(estadoSolicitudes) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_DOMICILIARIA &&
        props.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA)
    ) || (solicitudSeleccionada?.idSolicitud !== null && solicitudSeleccionada?.idEstadoSolicitud === undefined))
    : presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.EN_CARGA ||
    presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION);


  return (
    <Accordion TransitionProps={{ unmountOnExit: true }} style={{ marginLeft: 45 }}>
      <AccordionSummary expandIcon={<ChevronDown />}>
        <Typography variant="h6">
          Materiales
          {props.estaCorrecto ? <CheckCircle /> : <AlertCircle />}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ValidatorForm onSubmit={onSubmitHandler} style={{ flexGrow: 1 }}>
          {enabledMaterialActions && /* !props.desdeAuditar && */ (
            <Grid
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Grid container>
                <Grid item xs={1} sm={1} md={2} lg={3}></Grid>
                <Grid item xs={10} sm={10} md={8} lg={6}>
                  <BuscadorMateriales
                    ref={codigoMaterialRef}
                    cod={codigoMaterial}
                    label="Código Material"
                    // fieldsDisabled={props.esDenunciaInternacion}
                    setCod={(val) => setCodigoMaterial(val)}
                  />
                </Grid>
                <Grid item xs={1} sm={1} md={2} lg={3}></Grid>
              </Grid>
              <Button
                style={{ margin: "2rem" }}
                variant="contained"
                color="primary"
                type="submit"
                // disabled={props.esDenunciaInternacion || props.disabled}
                disabled={props.disabled}
              >
                + Agregar Material
              </Button>
            </Grid>
          )}
          {props.practica?.materiales?.length > 0 && (
            <Grid item xs={12}>
              <Table>
                <TableHead>
                  <TableRow>
                    {enabledMaterialActions && /* !props.desdeAuditar && */ (
                      <TableCell style={{ width: "7%" }}></TableCell>
                    )}
                    <TableCell style={{ width: solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PRESUPUESTOS || presupuestoSeleccionado?.idPresupuesto !== null ? "55%" : "78%" }}>Descripción</TableCell>
                    <TableCell style={{ width: "10%" }}>Cantidad</TableCell>
                    {props.desdeAuditar &&
                      (presupuestoSeleccionado?.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS ||
                        presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS ||
                        presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
                      ) && (solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PRESUPUESTOS || presupuestoSeleccionado?.idPresupuesto !== null)
                      && <TableCell style={{ width: "23%" }}>Valor Uni.</TableCell>}
                    <TableCell style={{ width: "10%", textAlign: 'center' }}>SURGE</TableCell>
                    {props.desdeAuditar && !props.noMostrarEstado && (
                      <React.Fragment>
                        <TableCell>Estado</TableCell>
                        {props.desdeAuditar && solicitudSeleccionada?.idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION
                          &&
                          <TableCell>Tipo Provisión</TableCell>
                        }
                        {parseInt(estadoSolicitudes) ===
                          AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_MATERIALES && (
                            <TableCell></TableCell>
                          )}
                      </React.Fragment>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.practica?.materiales.map((material, index) => {
                    return (
                      <AutorizacionesMaterial
                        index={index}
                        material={material}
                        disabled={props.disabled}
                        practica={props.practica}
                        desdeAuditar={props.desdeAuditar}
                        disabledRecupSur={!enabledRecupSur}
                        key={material?.idMaterial.toString()}
                        materiales={props.practica?.materiales}
                        noMostrarEstado={props.noMostrarEstado}
                        enabledMaterialActions={enabledMaterialActions}
                        esDenunciaInternacion={props.esDenunciaInternacion}
                        evaluarPracticasMateriales={props.evaluarPracticasMateriales}
                        permiteAgregarPracticaPeriodo={props.permiteAgregarPracticaPeriodo}
                        solicitudSeleccionada={solicitudSeleccionada}
                        presupuestoSeleccionado={presupuestoSeleccionado}
                      />
                    );
                  })}
                </TableBody>
              </Table>
            </Grid>
          )}
        </ValidatorForm>
      </AccordionDetails>
    </Accordion>
  );
};
